import _ from 'lodash';
import batterTooltip from '../tooltip/batterTooltip';
import { useTranslation } from 'react-i18next';

export default function BatterTableColumnSet(type) {
    let columnSet = [];
    let tooltipData = batterTooltip();
    const { t } = useTranslation();

    if(type === 'total') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('age'), property: 'age'});
        columnSet.push({column: t('basicStat_gameCnt'), property: 'basicStat_gameCnt'});
        columnSet.push({column: t('basicStat_tpa'), property: 'basicStat_tpa'});
        columnSet.push({column: t('basicStat_hit'), property: 'basicStat_hit'});
        columnSet.push({column: t('basicStat_b2b'), property: 'basicStat_b2b'});
        columnSet.push({column: t('basicStat_b3b'), property: 'basicStat_b3b'});
        columnSet.push({column: t('basicStat_hr'), property: 'basicStat_hr'});
        columnSet.push({column: t('basicStat_sbSucc'), property: 'basicStat_sbSucc'});
        columnSet.push({column: t('basicStat_k'), property: 'basicStat_so'});
        columnSet.push({column: t('basicStat_bb'), property: 'basicStat_bb', cellRender: totalBbRender});
        columnSet.push({column: t('avg'), property: 'avg'});
        columnSet.push({column: t('obp'), property: 'obp', tooltip:tooltipData['obp']});
        columnSet.push({column: t('slg'), property: 'slg', tooltip:tooltipData['slg']});
        columnSet.push({column: t('ops'), property: 'ops', tooltip:tooltipData['ops']});
        columnSet.push({column: t('babip'), property: 'babip', tooltip: tooltipData['babip']}); 
        columnSet.push({column: t('kRate'), property: 'kRate', tooltip: tooltipData['kRate']}); 
        columnSet.push({column: t('bbRate'), property: 'bbRate', tooltip: tooltipData['bbRate']}); 
        columnSet.push({column: t('hardHitRate(T)'), property: 'hardHitRate', tooltip: tooltipData['hardHitRate']}); 
        columnSet.push({column: t('barrelRate(T)'), property: 'barrelRate', tooltip: tooltipData['barrelRate']}); 
        columnSet.push({column: t('vaildHitRate(T)'), property: 'vaildHitRate', tooltip:tooltipData['vaildHitRate']});
    } else if(type === 'futuresTotal') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('age'), property: 'age'});
        // columnSet.push({column: t('basicStat_gameCnt'), property: 'gameCnt'});
        columnSet.push({column: t('basicStat_tpa'), property: 'pa'});
        columnSet.push({column: t('basicStat_hit'), property: 'hit'});
        columnSet.push({column: t('basicStat_b2b'), property: 'b2b'});
        columnSet.push({column: t('basicStat_b3b'), property: 'b3b'});
        columnSet.push({column: t('basicStat_hr'), property: 'hr'});
        columnSet.push({column: t('basicStat_sbSucc'), property: 'sb'});
        columnSet.push({column: t('basicStat_k'), property: 'so'});
        columnSet.push({column: t('basicStat_bb'), property: 'bb', cellRender: totalBbRender});
        columnSet.push({column: t('avg'), property: 'avg'});
        columnSet.push({column: t('obp'), property: 'obp', tooltip:tooltipData['obp']});
        columnSet.push({column: t('slg'), property: 'slg', tooltip:tooltipData['slg']});
        columnSet.push({column: t('ops'), property: 'ops', tooltip:tooltipData['ops']});
        columnSet.push({column: t('babip'), property: 'babip', tooltip: tooltipData['babip']}); 
        columnSet.push({column: t('kRate'), property: 'kRate', tooltip: tooltipData['kRate']}); 
        columnSet.push({column: t('bbRate'), property: 'bbRate', tooltip: tooltipData['bbRate']}); 
        columnSet.push({column: t('hardHitRate(T)'), property: 'hardHitRate', tooltip: tooltipData['hardHitRate']}); 
        columnSet.push({column: t('barrelRate(T)'), property: 'barrelRate', tooltip: tooltipData['barrelRate']}); 
        columnSet.push({column: t('vaildHitRate(T)'), property: 'solidContactRate', tooltip:tooltipData['vaildHitRate']});
    } else if(type === 'contact') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('basicStat_ab'), property: 'basicStat_ab'});
        columnSet.push({column: t('zoneContactRate'), property: 'zoneContactRate', tooltip:tooltipData['zoneContactRate']});
        columnSet.push({column: t('oSwingRate'), property: 'oSwingRate', tooltip:tooltipData['chaseRate']});
        columnSet.push({column: t('whiffRate'), property: 'whiffRate', tooltip: tooltipData['whiffRate']});
        // columnSet.push({column: '가운데\n스윙%', property: ''});
        columnSet.push({column: t('swingRate'), property: 'swingRate', tooltip: tooltipData['swingRate']});
        columnSet.push({column: t('firstPitchSwingRate'), property: 'firstPitchSwingRate', tooltip: tooltipData['firstPitchSwingRate']});
        columnSet.push({column: t('firstPitchContactRate'), property: 'firstPitchContactRate', tooltip: tooltipData['firstPitchContactRate']});
        columnSet.push({column: t('twoStrikePitchSwingRate'), property: 'twoStrikePitchSwingRate', tooltip: tooltipData['twoStrikePitchSwingRate']});
        columnSet.push({column: t('twoStrikePitchOSwingRate'), property: 'twoStrikePitchOSwingRate',tooltip: tooltipData['twoStrikePitchChaseRate']});
        columnSet.push({column: t('twoStrikePitchContactRate'), property: 'twoStrikePitchContactRate', tooltip: tooltipData['twoStrikePitchContactRate']});
        columnSet.push({column: t('bbRate'), property: 'bbRate', tooltip: tooltipData['bbRate']}); 
        columnSet.push({column: t('kRate'), property: 'kRate', tooltip: tooltipData['kRate']}); 
        columnSet.push({column: t('tpaDivPitch'), property: 'tpaDivPitch', tooltip: tooltipData['tpaDivPitch']}); 
    } else if(type === 'futuresContact') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('basicStat_ab'), property: 'ab'});
        columnSet.push({column: t('zoneContactRate'), property: 'zoneContactRate', tooltip:tooltipData['zoneContactRate']});
        columnSet.push({column: t('oSwingRate'), property: 'chaseRate', tooltip:tooltipData['chaseRate']});
        columnSet.push({column: t('whiffRate'), property: 'whiffRate', tooltip: tooltipData['whiffRate']});
        // columnSet.push({column: '가운데\n스윙%', property: ''});
        columnSet.push({column: t('swingRate'), property: 'swingRate', tooltip: tooltipData['swingRate']});
        columnSet.push({column: t('firstPitchSwingRate'), property: 'firstPitchSwingRate', tooltip: tooltipData['firstPitchSwingRate']});
        columnSet.push({column: t('firstPitchContactRate'), property: 'firstPitchContactRate', tooltip: tooltipData['firstPitchContactRate']});
        columnSet.push({column: t('twoStrikePitchSwingRate'), property: 'twoStrikePitchSwingRate', tooltip: tooltipData['twoStrikePitchSwingRate']});
        columnSet.push({column: t('twoStrikePitchOSwingRate'), property: 'twoStrikePitchChaseRate',tooltip: tooltipData['twoStrikePitchChaseRate']});
        columnSet.push({column: t('twoStrikePitchContactRate'), property: 'twoStrikePitchContactRate', tooltip: tooltipData['twoStrikePitchContactRate']});
        columnSet.push({column: t('bbRate'), property: 'bbRate', tooltip: tooltipData['bbRate']}); 
        columnSet.push({column: t('kRate'), property: 'kRate', tooltip: tooltipData['kRate']}); 
        columnSet.push({column: t('tpaDivPitch'), property: 'pitchPerPa', tooltip: tooltipData['tpaDivPitch']}); 
    } else if(type === 'power') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('inplay'), property: 'inplay'});
        columnSet.push({column: t('barrelHit'), property: 'barrelHit', tooltip: tooltipData['barrelHit']});
        columnSet.push({column: t('barrelRate'), property: 'barrelRate', tooltip: tooltipData['barrelRate']});
        columnSet.push({column: t('vaildHitRate'), property: 'vaildHitRate', tooltip: tooltipData['vaildHitRate']});
        columnSet.push({column: t('avgExitSpeed'), property: 'avgExitSpeed'});
        columnSet.push({column: t('maxExitSpeed'), property: 'maxExitSpeed'});
        // columnSet.push({column: '로파워\n지표', property: 'raw_power_speed', tooltip: tooltipData['raw_power_speed'], cellRender: toFixedCellRender});
        columnSet.push({column: t('avgAngle'), property: 'avgAngle'});
        // columnSet.push({column: '유효\n각도%', property: ''});
        columnSet.push({column: t('hardHitRate'), property: 'hardHitRate', tooltip: tooltipData['hardHitRate']});
        columnSet.push({column: t('ba2'), property: 'avg'});
        columnSet.push({column: t('xBa'), property: 'xBa', tooltip: tooltipData['xBa'], cellRender: leadingZeroCellRender});
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg']});
        columnSet.push({column: t('xSlg'), property: 'xSlg', tooltip: tooltipData['xSlg'], cellRender: leadingZeroCellRender});
    } else if(type === 'futuresPower') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('inplay'), property: 'inplay'});
        columnSet.push({column: t('barrelHit'), property: 'barrel', tooltip: tooltipData['barrelHit']});
        columnSet.push({column: t('barrelRate'), property: 'barrelRate', tooltip: tooltipData['barrelRate']});
        columnSet.push({column: t('vaildHitRate'), property: 'solidContactRate', tooltip: tooltipData['vaildHitRate']});
        columnSet.push({column: t('avgExitSpeed'), property: 'avgExitSpeed'});
        columnSet.push({column: t('maxExitSpeed'), property: 'maxExitSpeed'});
        // columnSet.push({column: '로파워\n지표', property: 'raw_power_speed', tooltip: tooltipData['raw_power_speed'], cellRender: toFixedCellRender});
        columnSet.push({column: t('avgAngle'), property: 'avgAngle'});
        // columnSet.push({column: '유효\n각도%', property: ''});
        columnSet.push({column: t('hardHitRate'), property: 'hardHitRate', tooltip: tooltipData['hardHitRate']});
        columnSet.push({column: t('ba2'), property: 'avg'});
        columnSet.push({column: t('xBa'), property: 'xba', tooltip: tooltipData['xBa'], cellRender: leadingZeroCellRender});
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg']});
        columnSet.push({column: t('xSlg'), property: 'xslg', tooltip: tooltipData['xSlg'], cellRender: leadingZeroCellRender});
    } else if(type === 'hittingType') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('groundBallRate'), property: 'groundBallRate', tooltip: tooltipData['gdRate']});
        columnSet.push({column: t('flyRate'), property: 'flyRate', tooltip: tooltipData['flyRate']});
        columnSet.push({column: t('lineDriveRate'), property: 'lineDriveRate', tooltip: tooltipData['lineRate']});
        columnSet.push({column: t('popUpRate'), property: 'popUpRate', tooltip: tooltipData['popUpRate']});
        columnSet.push({column: t('hangRate'), property: 'hangRate', tooltip: tooltipData['hangRate']});
        columnSet.push({column: t('centerRate'), property: 'centerRate', tooltip: tooltipData['centerRate']});
        columnSet.push({column: t('pushRate'), property: 'pushRate', tooltip: tooltipData['pushRate']});
        columnSet.push({column: t('barrelRate'), property: 'barrelRate', tooltip: tooltipData['barrelRate']});
        columnSet.push({column: t('vaildHitRate'), property: 'vaildHitRate', tooltip: tooltipData['vaildHitRate']});
        columnSet.push({column: t('poorlyUnderRate'), property: 'poorlyUnderRate', tooltip: tooltipData['poorlyUnderRate']});
        columnSet.push({column: t('poorlyToppedRate'), property: 'poorlyToppedRate', tooltip: tooltipData['poorlyToppedRate']});
        // columnSet.push({column: '얕은타구', property: ''});
    } else if(type === 'futuresHittingType') {
        columnSet.push({column: t('season'), property: 'season'});
        columnSet.push({column: t('groundBallRate'), property: 'groundBallRate', tooltip: tooltipData['gdRate']});
        columnSet.push({column: t('flyRate'), property: 'flyRate', tooltip: tooltipData['flyRate']});
        columnSet.push({column: t('lineDriveRate'), property: 'lineDriveRate', tooltip: tooltipData['lineRate']});
        columnSet.push({column: t('popUpRate'), property: 'popUpRate', tooltip: tooltipData['popUpRate']});
        columnSet.push({column: t('hangRate'), property: 'hangRate', tooltip: tooltipData['hangRate']});
        columnSet.push({column: t('centerRate'), property: 'centerRate', tooltip: tooltipData['centerRate']});
        columnSet.push({column: t('pushRate'), property: 'pushRate', tooltip: tooltipData['pushRate']});
        columnSet.push({column: t('barrelRate'), property: 'barrelRate', tooltip: tooltipData['barrelRate']});
        columnSet.push({column: t('vaildHitRate'), property: 'solidContactRate', tooltip: tooltipData['vaildHitRate']});
        columnSet.push({column: t('poorlyUnderRate'), property: 'poorlyUnderRate', tooltip: tooltipData['poorlyUnderRate']});
        columnSet.push({column: t('poorlyToppedRate'), property: 'poorlyToppedRate', tooltip: tooltipData['poorlyToppedRate']});
        // columnSet.push({column: '얕은타구', property: ''});
    } else if(type === 'count' || type === 'runnerType' || type === 'ballCode') {
        columnSet.push({column: t('type'), property: 'type'});
        columnSet.push({column: t('basicStat_tpa'), property: 'basicStat_tpa'});
        columnSet.push({column: t('basicStat_ab'), property: 'basicStat_ab'});
        columnSet.push({column: t('basicStat_hit'), property: 'basicStat_hit'});
        columnSet.push({column: t('basicStat_b2b'), property: 'basicStat_b2b'});
        columnSet.push({column: t('basicStat_b3b'), property: 'basicStat_b3b'});
        columnSet.push({column: t('basicStat_hr'), property: 'basicStat_hr'});
        columnSet.push({column: t('basicStat_so'), property: 'basicStat_so'});
        columnSet.push({column: t('basicStat_bb'), property: 'basicStat_bb', cellRender: totalBbRender});
        columnSet.push({column: t('basicStat_hbp'), property: 'basicStat_hbp'});
        columnSet.push({column: t('basicStat_sf'), property: 'basicStat_sf'});
        columnSet.push({column: t('avg'), property: 'avg'});
        columnSet.push({column: t('obp'), property: 'obp', tooltip: tooltipData['obp']});
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg']});
        columnSet.push({column: t('ops'), property: 'ops', tooltip: tooltipData['ops']});
    } else if(type === 'futuresCount' || type === 'futuresBallCode') {
        columnSet.push({column: t('type'), property: 'type'});
        columnSet.push({column: t('basicStat_tpa'), property: 'tpa'});
        columnSet.push({column: t('basicStat_ab'), property: 'ab'});
        columnSet.push({column: t('basicStat_hit'), property: 'hit'});
        columnSet.push({column: t('basicStat_b2b'), property: 'b2b'});
        columnSet.push({column: t('basicStat_b3b'), property: 'b3b'});
        columnSet.push({column: t('basicStat_hr'), property: 'hr'});
        columnSet.push({column: t('basicStat_so'), property: 'so'});
        columnSet.push({column: t('basicStat_bb'), property: 'bb', cellRender: totalBbRender});
        columnSet.push({column: t('basicStat_hbp'), property: 'hbp'});
        columnSet.push({column: t('basicStat_sf'), property: 'sf'});
        columnSet.push({column: t('avg'), property: 'avg'});
        columnSet.push({column: t('obp'), property: 'obp', tooltip: tooltipData['obp']});
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg']});
        columnSet.push({column: t('ops'), property: 'ops', tooltip: tooltipData['ops']});
    } else if(type === 'pitcherType') {
        columnSet.push({column: t('type'), property: 'type'});
        columnSet.push({column: t('basicStat_tpa'), property: 'basicStat_tpa'});
        columnSet.push({column: t('basicStat_ab'), property: 'basicStat_ab'});
        columnSet.push({column: t('basicStat_hit'), property: 'basicStat_hit'});
        columnSet.push({column: t('basicStat_b2b'), property: 'basicStat_b2b'});
        columnSet.push({column: t('basicStat_b3b'), property: 'basicStat_b3b'});
        columnSet.push({column: t('basicStat_hr'), property: 'basicStat_hr'});
        columnSet.push({column: t('basicStat_rbi'), property: 'basicStat_rbi'});
        // columnSet.push({column: '도루', property: 'basicStat_sbSucc'});
        columnSet.push({column: t('basicStat_so'), property: 'basicStat_so'});
        columnSet.push({column: t('basicStat_bb'), property: 'basicStat_bb', cellRender: totalBbRender});
        columnSet.push({column: t('basicStat_hbp'), property: 'basicStat_hbp'});
        columnSet.push({column: t('basicStat_sf'), property: 'basicStat_sf'});
        columnSet.push({column: t('basicStat_sb'), property: 'basicStat_sb'});
        columnSet.push({column: t('avg'), property: 'avg'});
        columnSet.push({column: t('obp'), property: 'obp', tooltip: tooltipData['obp']});
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg']});
        columnSet.push({column: t('ops'), property: 'ops', tooltip: tooltipData['ops']});
        columnSet.push({column: t('babip'), property: 'babip', tooltip: tooltipData['babip']}); 
    } else if(type === 'futuresPitcherType') {
        columnSet.push({column: t('type'), property: 'type'});
        columnSet.push({column: t('basicStat_tpa'), property: 'tpa'});
        columnSet.push({column: t('basicStat_ab'), property: 'ab'});
        columnSet.push({column: t('basicStat_hit'), property: 'hit'});
        columnSet.push({column: t('basicStat_b2b'), property: 'b2b'});
        columnSet.push({column: t('basicStat_b3b'), property: 'b3b'});
        columnSet.push({column: t('basicStat_hr'), property: 'hr'});
        columnSet.push({column: t('basicStat_rbi'), property: 'rbi'});
        columnSet.push({column: t('basicStat_so'), property: 'so'});
        columnSet.push({column: t('basicStat_bb'), property: 'bb', cellRender: totalBbRender});
        columnSet.push({column: t('basicStat_hbp'), property: 'hbp'});
        columnSet.push({column: t('basicStat_sf'), property: 'sf'});
        columnSet.push({column: t('basicStat_sb'), property: 'sb'});
        columnSet.push({column: t('avg'), property: 'avg'});
        columnSet.push({column: t('obp'), property: 'obp', tooltip: tooltipData['obp']});
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg']});
        columnSet.push({column: t('ops'), property: 'ops', tooltip: tooltipData['ops']});
        columnSet.push({column: t('babip'), property: 'babip', tooltip: tooltipData['babip']}); 
    } else if(type.indexOf('futures') > -1) {
        columnSet.push({column: t('type'), property: 'type'});
        // columnSet.push({column: t('basicStat_gameCnt'), property: 'gameCnt'});
        columnSet.push({column: t('basicStat_tpa'), property: 'tpa'});
        columnSet.push({column: t('basicStat_ab'), property: 'ab'});
        columnSet.push({column: t('basicStat_hit'), property: 'hit'});
        columnSet.push({column: t('basicStat_b2b'), property: 'b2b'});
        columnSet.push({column: t('basicStat_b3b'), property: 'b3b'});
        columnSet.push({column: t('basicStat_hr'), property: 'hr'});
        columnSet.push({column: t('basicStat_rbi'), property: 'rbi'});
        columnSet.push({column: t('basicStat_so'), property: 'so'});
        columnSet.push({column: t('basicStat_bb'), property: 'bb', cellRender: totalBbRender});
        columnSet.push({column: t('basicStat_hbp'), property: 'hbp'});
        columnSet.push({column: t('basicStat_sf'), property: 'sf'});
        columnSet.push({column: t('basicStat_sb'), property: 'sb'});
        columnSet.push({column: t('avg'), property: 'avg'});
        columnSet.push({column: t('obp'), property: 'obp', tooltip: tooltipData['obp']});
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg']});
        columnSet.push({column: t('ops'), property: 'ops', tooltip: tooltipData['ops']});
        columnSet.push({column: t('babip'), property: 'babip', tooltip: tooltipData['babip']});
    } else {
        columnSet.push({column: t('type'), property: 'type'});
        columnSet.push({column: t('basicStat_gameCnt'), property: 'basicStat_gameCnt'});
        columnSet.push({column: t('basicStat_tpa'), property: 'basicStat_tpa'});
        columnSet.push({column: t('basicStat_ab'), property: 'basicStat_ab'});
        columnSet.push({column: t('basicStat_hit'), property: 'basicStat_hit'});
        columnSet.push({column: t('basicStat_b2b'), property: 'basicStat_b2b'});
        columnSet.push({column: t('basicStat_b3b'), property: 'basicStat_b3b'});
        columnSet.push({column: t('basicStat_hr'), property: 'basicStat_hr'});
        columnSet.push({column: t('basicStat_rbi'), property: 'basicStat_rbi'});
        // columnSet.push({column: '도루', property: 'basicStat_sbSucc'});
        columnSet.push({column: t('basicStat_so'), property: 'basicStat_so'});
        columnSet.push({column: t('basicStat_bb'), property: 'basicStat_bb', cellRender: totalBbRender});
        columnSet.push({column: t('basicStat_hbp'), property: 'basicStat_hbp'});
        columnSet.push({column: t('basicStat_sf'), property: 'basicStat_sf'});
        columnSet.push({column: t('basicStat_sb'), property: 'basicStat_sb'});
        columnSet.push({column: t('avg'), property: 'avg'});
        columnSet.push({column: t('obp'), property: 'obp', tooltip: tooltipData['obp']});
        columnSet.push({column: t('slg'), property: 'slg', tooltip: tooltipData['slg']});
        columnSet.push({column: t('ops'), property: 'ops', tooltip: tooltipData['ops']});
        columnSet.push({column: t('babip'), property: 'babip', tooltip: tooltipData['babip']}); 
    }

    columnSet.forEach((item, idx) => {
        item['key'] = type+(idx+"");
    });

    return columnSet;
}

function toFixedCellRender(key, property, data) {
    let innerData = data[property];
    return <td key={key}>{(innerData*1).toFixed(1)}</td>
}

function percentCellRender(key, property, data) {
    let innerData = data[property];
    let fixedData = (innerData*100).toFixed(1);
    return <td key={key}>{fixedData}</td>
}

function leadingZeroCellRender(key, property, data) {
    let innerData = data[property];
    let fixedData = statString(innerData);

    return <td key={key}>{fixedData}</td>
}

function commonCellRender(key, property, data) {
    let innerData = data[property];
    return <td key={key}>{innerData}</td>
}

function statString(stat) {
    let statStringInit = '';

    if(stat*1 === 0) {
        statStringInit = '.000';
    } else if(Number.isInteger(stat)) { // integer
        statStringInit = stat+".000";
    } else if(stat > 0 && stat < 1)  {
        let basicStat = (stat*1).toPrecision(3);
        statStringInit = basicStat.slice(1,5);
    } else if(stat > 1){ 
        let basicStat = (stat*1).toPrecision(4);
        statStringInit = basicStat;
    }

    return statStringInit;
}

function totalBbRender(key, property, data) {
    let ibb = _.isUndefined(data['basicStat_ibb']) ? data['ibb'] : data['basicStat_ibb'];
    let totalBb = ibb*1+data[property]*1;

    return <td key={key}>{totalBb}</td>;
}